__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-04-15-1776235133-stable-dev/";